import { useQuery } from "@tanstack/react-query";
import { AIModelProvider } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const useModelProviders = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["ai-model-providers"],
    queryFn: () => defaultOnError(
      AIModelProvider.providers(),
      "Loading model providers failed",
      "Could not load model providers"
    )
  });
  return { data: data != null ? data : [], isLoading };
};
export default useModelProviders;
